import { Box, TextField, Button, Typography } from "@mui/material";

// const formData = [
//     { label: "Fullname", val: "Norilyn Mingi", type: "text", required: true },
//     { label: "Mobile Number", val: " 092255456547", type: "text", required: true },
//     { label: "Email", val: " juanmanalo@yahoo.com", type: "email", required: true },
//     { label: "Message", val: "How to apply as agent?", type: "text", multiline: true, rows: 4 },
// ];

const formData = [ "Full Name", "Mobile Number", "Email" ]

export const MessageUs = () => {
  return (
        <Box height="77%" className="overflowY">
            <Box
                sx={{
                    width: "100%",
                    maxWidth: 400,
                    mx: "auto",
                    p: "1rem",
                }}
            >
                <Typography variant="h6" fontWeight={550} sx={{ mb: "0.5rem" }}>
                    Contact Us
                </Typography>
                {formData.map((v, i) => (
                    <TextField key={i} size='small' fullWidth label={v} required disabled InputLabelProps={{ sx: { '& .MuiFormLabel-asterisk': { color: 'error.main', }, }, }} sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, mb: "1rem" }}/>
                ))}
                <Box mt="0.5rem">
                    <TextField size='small' required fullWidth disabled label="Message" sx={{ '& .MuiInputBase-root': { backgroundColor: '#ffffff' }, backgroundColor: "#ffffff" }}
                        inputProps={{ 
                            style: {
                                height: "8rem"
                            }
                        }} 
                        InputLabelProps={{
                            sx: { 
                                fontStyle: "italic", 
                                '& .MuiFormLabel-asterisk': { color: 'error.main'} 
                            }
                        }}
                    />
                </Box>
                <Box display="flex" justifyContent="center">
                    <Button variant="contained" color="primary" disabled sx={{ my: "1rem" }}>
                        Submit
                    </Button>
                </Box>
            </Box>
        </Box>
    )
}
